import { faDollarCircle } from "@fortawesome/pro-solid-svg-icons"
import { canInvoiceBeMarkedNotPaidManually, InvoiceSummary } from "../../../domain/invoicing/invoice"
import { useMarkInvoiceNotPaidManuallyMutation } from "../../../domain/invoicing/invoicingQueries"
import { Popconfirm } from "antd"
import ThemableButton from "../../Items/ThemableButton"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

type Props = {
  summary: InvoiceSummary
  disabled?: boolean
}

const ManualMarkNotPaidButton = ({summary, disabled}: Props) => {
  const notPaidMutation = useMarkInvoiceNotPaidManuallyMutation()

  if (canInvoiceBeMarkedNotPaidManually(summary)) {
    return <Popconfirm
      title="Are you sure you want to manually mark this invoice not paid?"
      okText="Yes"
      cancelText="No"
      onConfirm={() => notPaidMutation.mutate(summary.invoiceId)}
    >
      <ThemableButton
        type="primary"
        colorPrimary="#565656"
        icon={<FontAwesomeIcon icon={faDollarCircle}/>}
        disabled={disabled || notPaidMutation.isLoading}
      >Mark Invoice Not Paid</ThemableButton>
    </Popconfirm>
  }

  return null
}

export default ManualMarkNotPaidButton